// extracted by mini-css-extract-plugin
export default {"retailMomo":"retailMomo_retailMomo__rLoYv","container":"retailMomo_container__EKEK4"};